import dayjs from 'dayjs';
import {
    dateTimeFormatsView,
    preferredDateTimeFormatInternally,
} from '@src/application/constraints/date-time-constraints.js';

export default {
    formatDatetimeToView(datetime: string): string {
        return dayjs(datetime, preferredDateTimeFormatInternally)
            .format(dateTimeFormatsView.short);
    },
};
